import { isNil, mapToObject } from "../utils/Utils";
export class AppInfo {
    constructor(tenants = new Array()) {
        this.tenants = tenants;
    }
    addFromAppInfo(appInfo, index) {
        this.tenants.push(appInfo.tenants[index]);
        if (!isNil(appInfo.role)) {
            this.role = appInfo.role;
        }
        else if (Array.isArray(appInfo.roles) && appInfo.roles.length > 0) {
            if (isNil(this.roles)) {
                this.roles = new Array();
            }
            this.roles.push(appInfo.roles[index]);
        }
        else {
            throw new Error(`No role/roles.`);
        }
    }
    setAppInfo(tenantIds, roles, role) {
        this.tenants = tenantIds;
        if (!isNil(role)) {
            this.role = role;
        }
        else if (Array.isArray(roles) && roles.length > 0) {
            this.roles = roles;
        }
        else {
            throw new Error(`No role/roles.`);
        }
    }
    toObject() {
        const objectFromAppInfo = Object.create(null);
        objectFromAppInfo["tenants"] = this.tenants;
        if (!isNil(this.role)) {
            objectFromAppInfo["role"] = this.role;
        }
        if (!isNil(this.roles)) {
            objectFromAppInfo["roles"] = this.roles;
        }
        if (!isNil(this.associations)) {
            const associations = [];
            for (const association of this.associations) {
                associations.push(mapToObject(association));
            }
            objectFromAppInfo["associations"] = associations;
        }
        return objectFromAppInfo;
    }
}
